import restaurantModalLoginInstance from '../../../modalLoginInstance'
import restaurantInstance from '../../../instance'

const updateOrderItemStatus = (tableId, orderId, itemPositionId, status, hasModalLogin = true) => {
  return (hasModalLogin ? restaurantModalLoginInstance : restaurantInstance)
    .put(`/tables/${tableId}/orders/${orderId}/items/${itemPositionId}/status`, { status })
}

export default updateOrderItemStatus
